export default "__VITE_ASSET__RthuKAq$__"